<!-- UsageGuideDialog.vue -->
<template>
  <v-dialog :model-value="modelValue" max-width="800px" @update:modelValue="onDialogModelUpdate">
    <v-card>
      <DialogTitleBar>
        서비스 이용안내
        <template #actions>
          <v-btn icon variant="text" @click="openNaverCafe" aria-label="네이버 카페">
            <v-img
              :src="naverCafe"
              alt="네이버 카페"
              max-width="24"
              max-height="24"
              contain
            />
          </v-btn>

          <v-btn icon variant="text" @click="openKakaoTalk" aria-label="카카오톡 오픈채팅">
            <v-img
              :src="kakaoTalk"
              alt="카카오톡 오픈채팅"
              max-width="24"
              max-height="24"
              contain
            />
          </v-btn>

          <v-btn icon variant="text" aria-label="닫기" @click="closeDialog">
            <svg-icon type="mdi" :path="icons.mdiClose" />
          </v-btn>
        </template>
      </DialogTitleBar>
      <v-card-text class="usage-guide-body">
        <div class="usage-guide-content">
          {{ usageGuideContent }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="closeDialog">닫기</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogTitleBar from '@/components/DialogTitleBar.vue';
import icons from '@/icons';
import naverCafe from '@/assets/naver_cafe_green.png';
import kakaoTalk from '@/assets/kakaotalk_btn.png';

export default {
  name: 'UsageGuideDialog',
  components: {
    DialogTitleBar,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      icons,
      naverCafe,
      kakaoTalk,
      usageGuideContent: `
1. 서비스 소개
 • 인공지능을 활용하여 학생부 특기사항 작성을 지원하는 서비스로, 입력된 학생의 정보를 바탕으로 맞춤형 특기사항을 생성합니다.
 • 인공지능 모델 사용료(OpenAi)와 웹페이지 호스팅(Google) 비용을 지불해야 하는 유료 서비스입니다.

2. 유의사항
 • 생성된 특기사항은 참고자료로 활용하시기 바랍니다. 실제 작성 시에는 교사의 전문적인 판단이 필요합니다.
 • 가입할 때 제공하는 무료 크레딧 수량은 예고없이 변경될 수 있습니다.
 
3. 로그인
 • 구글 계정 인증만 지원합니다.
 • 구글 계정을 사용하시기에 불편 하신분은 요청하시면 다른 인증을 추가하겠습니다.

4. 시스템 설정(!!특기사항을 생성하기 전에 반드시 설정!!)
  1) 모델 선택
   • 기존 설정에 저장된 긴 내용을 짧게 정리하는 미세조정 모델은 당분간 사용할 수 있습니다. 신규 개인화 미세조정 모델 제공은 종료되었습니다.
   • gpt-4.1(OpenAI사의 최신 모델)
   • solar-pro(한국의 AI 전문기업인 Upstage 사의 최신 모델, 2027-1-31까지 무료)

  2) AI가 할 일(AI가 작성해 줄 특기사항의 종류)
   • 과목별 세부능력 및 특기사항 또는 창의적 체험활동 특기사항, 행동특성 및 발달상황 중 선택하거나
   • 직접 입력(예: 모범학생 추천사유 등)

  3) 과목 또는 분야
   • 과목명, 동아리 활동, 자율 활동, 자율 활동 중 특정 분야, 행특 중 특정 분야 등  

  4) 학생들이 수행한 활동 내용
   • 수업 시간이나 수행 평가로 학생이 한 활동

  5) 학생별로 AI에게 제공할 자료의 제목이나 목록
   • 교사의 관찰 평가, 학생의 자기 평가, 동료 평가 등
   • 보고서 제목과 내용, 발표 제목과 내용 등

  6) 특기사항에 포함할 내용 또는 역량

  7) 최소 바이트(많이 생성하려면 증가), 최대 바이트(적게 생성하려면 감소)

  8) 조건
   • 작성 순서
   • 평가 점수에 따른 특기사항의 내용(또는 바이트)
   • 반드시 포함시켜야 하는 것
   • 포함시키면 안되는 것
   • 작성 예시 등등

  9) OpenAI 파라미터 탭
   • 특기사항 생성의 창의성 조절
   • 같은 단어나 주제가 반복하여 생성되는 것을 제한   

  10) 금지어 변환 탭
   • 학생부에 입력할 수 없는 단어의 변환 설정 

5. 메인 화면 상단 고정 메뉴
  1) 학생 수와 학생 추가
  2) 다수의 학생을 선택하여 삭제
  3) 다수의 학생을 선택하여 특기사항 생성
  4) 다수의 학생을 선택하여 엑셀 파일 생성
  5) 설문 응답(엑셀 파일) 가져오기

6. 메인 화면 학생 테이블
  # 학번과 제공 자료(보고서 제목과 내용, 관찰평가, 자기평가 등)는 엑셀이나 구글 시트를 다중 선택 복사(Ctrl-C)하여 동시에 붙여넣기(Ctrl-V) 가능
  # 제공 자료와 특기사항은 "Ctrl + 마우스 스크롤"로 확대 축소 가능

  1) 학번 또는 이름(선택사항)
    예시) 15, 30115, 홍길동, 15/홍길동, 30115/홍길동
  
  2) 학생별 제공 자료(보고서 제목과 내용, 관찰평가, 자기평가 등)
   • 최대 5,000자
   • 특기사항 생성 버튼으로 해당 학생의 특기사항 생성

   3) 특기사항
   • 제공한 자료를 바탕으로 생성된 특기사항을 사용자(교사)가 직접 퇴고 가능
   • 복사하여 나이스에 붙여넣기 가능
   • 엑셀 파일을 생성하여 퇴고한 후, 나이스에 붙여넣기 가능
   • 읽기(TTS) 버튼
   • 특기사항 복사(Ctrl-C) 버튼
`,
    };
  },
  methods: {
    onDialogModelUpdate(value) {
      this.$emit('update:modelValue', value);
    },
    closeDialog() {
      this.$emit('update:modelValue', false);
    },
    openNaverCafe() {
      window.open('https://cafe.naver.com/studentremarkhelper', '_blank');
    },
    openKakaoTalk() {
      window.open('https://open.kakao.com/o/sTf1el7g', '_blank');
    },
  },
};
</script>

<style scoped>
.usage-guide-body {
  padding-top: 4px;
}

.usage-guide-content {
  white-space: pre-wrap;
  font-size: 0.95rem;
  line-height: 1.55;
  color: rgba(0, 0, 0, 0.68);
  word-break: keep-all;
}

@media (max-width: 600px) {
  .usage-guide-content {
    font-size: 0.91rem;
    line-height: 1.5;
  }
}
</style>
